import { render, staticRenderFns } from "./Loans.vue?vue&type=template&id=68ea9e3e&scoped=true&"
import script from "./Loans.vue?vue&type=script&lang=js&"
export * from "./Loans.vue?vue&type=script&lang=js&"
import style0 from "./Loans.vue?vue&type=style&index=0&id=68ea9e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea9e3e",
  null
  
)

export default component.exports